import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { companyData, companyDataViewModel } from '../const/company-data';
import { itemSelectObject } from '../const/select';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { InspectionModel } from '../models/inspection.model';

@Injectable({
  providedIn: 'root'
})
export class OpenedInspectionRegistrationService {

  private urlDomain = `${ environment.apiUrl }/DomainValues`;
  private urlCompany = `${ environment.apiUrlV3 }/company`;
  private urlInspection = `${ environment.apiUrlV3 }/Inspection`;

  constructor(private http: HttpClient) { }

  setLocalStorageCompany(idCompany: string) {
    companyData.forEach((company: companyDataViewModel) => {
      if (company.companyId === idCompany) {
        localStorage.setItem('company', JSON.stringify(company));
      }
    });
  }

  getListSegment(): Promise<itemSelectObject[]> {
    return this.http.get<itemSelectObject[]>(`${ this.urlDomain }/Segments`).pipe(
      map((response: any) => {
        return response.data.filter(item => item.id !== '4' && item.id !== '5');
      }),
    ).toPromise();
  }

  getBrokerByCode(code: number, idCompany: string): Promise<any> {
    return this.http.get<any>(`${ this.urlCompany }/GetBrokerByCode?BrokerCode=${ code }&CompanyId=${ idCompany }`).pipe(
      map((response: any) => {
        return response;
      })
    ).toPromise();
  }

  createInspectionLoose(body: InspectionModel): Promise<any> {
    return this.http.post<InspectionModel>(`${ this.urlInspection }/CreateInspectionLoose`, body).pipe(
      map((response: any) => {
        return response;
      })
    ).toPromise();
  }
}
